import { Link, useHistory, useParams } from 'react-router-dom';

import { BaseURL } from '../../../../../base/env';
import FilterSort from '../../../../components/CategoryBar/FilterSort/FilterSort';
import sub_no_name from './../../../../../assets/images/icons/sub-no-name.png';
import { ReactComponent as BottomArrow } from './../../../../../assets/svg/bottom-arrow.svg';
import styles from './CategoryBar.module.css';

export const getSortedParams = (params) =>
  [
    params.id || null,
    params.sub || null,
    params.c3 || null,
    params.c4 || null,
    params.c5 || null,
    params.c6 || null
  ].filter((catItem) => catItem !== null);

const CategoryBar = ({
  categories,
  showFilterSort = true,
  activeCategory,
  setActiveCategory,
  withoutUrl
  // page = 'category',
}) => {
  // const location = useLocation();
  const history = useHistory();
  const params = useParams();
  const paramsArray = getSortedParams(params);

  if (!categories) {
    return null;
  }

  const SubList = categories.find((catItem) => {
    if (withoutUrl) {
      return catItem.id.toString() === (activeCategory || '').toString();
    }
    return catItem.id.toString() === paramsArray[paramsArray.length - 2];
  });

  if (!SubList || !SubList.sub_categories) {
    return null;
  }

  return (
    <div className={styles.CategoryBarContainer}>
      {categories ? (
        <div className={`${styles.ParentListContainer}`}>
          <div className={styles.ParentList}>
            {categories.map((pitem) => {
              const isActive = activeCategory.toString() === pitem.id.toString();
              return (
                <Link
                  key={pitem.id}
                  className={`${styles.ParentItem} ${isActive ? styles.Active : ''}`}
                  onClick={() => setActiveCategory(pitem.id.toString())}
                  to={
                    pitem.has_homepage
                      ? `/category/${paramsArray[0].toString()}/${pitem.id.toString()}`
                      : `/category/${paramsArray[0].toString()}/${pitem.id.toString()}/${pitem.id.toString()}`
                  }>
                  {pitem.name}
                </Link>
              );
            })}
          </div>
        </div>
      ) : null}
      {categories ? (
        <div className={`${styles.SubListContainer} ${styles.HasReturn}`}>
          <div className={styles.SubList}>
            {SubList.sub_categories.map((subItem) => {
              const isActive = withoutUrl
                ? false
                : paramsArray[paramsArray.length - 2].toString() === subItem.id.toString();
              const subParamsArray = getSortedParams(params);
              if (subParamsArray.length <= 1 && subItem.name === 'همه') {
                return null;
              }
              if (subItem.has_sub_categories && !withoutUrl) {
                subParamsArray.push(subItem.id.toString());
              } else if (!withoutUrl) {
                subParamsArray[subParamsArray.length - 1] = subItem.id.toString();
              } else if (withoutUrl) {
                if (subParamsArray.length === 0) {
                  subParamsArray.push('1', subItem.id.toString());
                } else {
                  subParamsArray.push(subItem.id.toString());
                }
              }

              const newUrl = `/category${subParamsArray.map((pitem) => `/${pitem}`).join('')}`;

              return (
                <Link key={subItem.id} className={styles.SubItem} to={newUrl}>
                  <div
                    className={`${styles.SubItemImageContainer} ${isActive ? styles.Active : ''}`}>
                    <img
                      alt={subItem.name}
                      className={styles.SubItemImage}
                      src={subItem.image ? BaseURL + subItem.image : sub_no_name}
                    />
                  </div>
                  <span className={styles.SubItemText}>{subItem.name}</span>
                </Link>
              );
            })}
          </div>

          {/* Back Butoton */}
          <div
            className={`${styles.BackContainer} ${styles.Active}`}
            onClick={() => {
              // const subParamsArray = getSortedParams(params);
              // subParamsArray.pop();
              // const newUrl = `/${page}${subParamsArray.map(pitem => `/${pitem}`).join('')}${location.search}`;
              // history.push(newUrl)
              history.goBack();
            }}>
            <BottomArrow className={styles.BottomArrow} />
          </div>
        </div>
      ) : null}
      {!!showFilterSort &&
      !!activeCategory &&
      !categories.find((citem) => Number(citem.id) === Number(activeCategory))?.has_homepage ? (
        <FilterSort category_id={activeCategory} />
      ) : null}
    </div>
  );
};

export default CategoryBar;
